import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function createSimulation(payload) {
  const { data } = await apiClient.post("/simulations", payload);
  return data;
}

export async function updateSimulation(id, payload) {
  const { data } = await apiClient.put(`/simulations/${id}`, payload);
  return data;
}

export async function listSimulations() {
  const { data } = await apiClient.get("/simulations");
  return data;
}

export async function getSimulation(id) {
  const { data } = await apiClient.get(`/simulations/${id}`);
  return data;
}

export async function deleteSimulation(id) {
  const { data } = await apiClient.delete(`/simulations/${id}`);
  return data;
}

// ---------- profile presets ----------
export async function listProfilePresets() {
  const { data } = await apiClient.get("/profile-presets");
  return data;
}

export async function getProfilePreset(id) {
  const { data } = await apiClient.get(`/profile-presets/${id}`);
  return data;
}

export async function createProfilePreset(payload) {
  const { data } = await apiClient.post("/profile-presets", payload);
  return data;
}

export async function updateProfilePreset(id, payload) {
  const { data } = await apiClient.put(`/profile-presets/${id}`, payload);
  return data;
}

export async function deleteProfilePreset(id) {
  const { data } = await apiClient.delete(`/profile-presets/${id}`);
  return data;
}

export async function reorderProfilePresets(items) {
  // items: [{ id, order }, …]
  const { data } = await apiClient.post("/profile-presets/reorder", { items });
  return data;
}



export async function getSettings() {
  const { data } = await apiClient.get("/settings");
  return data;
}

export async function updateSettings(payload) {
  const { data } = await apiClient.put("/settings", payload);
  return data;
}

// ---------- pdf export history ----------
export async function createPdfExport(payload) {
  const { data } = await apiClient.post("/pdf-exports", payload);
  return data;
}

export async function listPdfExports() {
  const { data } = await apiClient.get("/pdf-exports");
  return data;
}
